export function convertPascalCaseToCamelCase(data: {}): {} {
    if (!data) {
        return data;
    }
    if (typeof (data) !== 'object') {
        return data;
    }
    if (Array.isArray(data)) {
        return data.map(e => convertPascalCaseToCamelCase(e));
    }

    let result = {};
    for (let key of Object.keys(data)) {
        result[convertNamePascalCaseToCamelCase(key)] = convertPascalCaseToCamelCase(data[key]);
    }

    return result;
}

export function convertNamePascalCaseToCamelCase(name: string) {
    if (typeof (name) !== 'string') {
        throw new Error('Invalid argument');
    }

    if (!name.length) {
        return name;
    }

    let firstWordEndIndex = name.search(/[^A-Z][A-Z]/);

    if (firstWordEndIndex >= 0) {   // Found 2nd word
        return name.slice(0, firstWordEndIndex + 1).toLowerCase()   // First word
            + name.slice(firstWordEndIndex + 1);                    // Remaining    
    }

    // else: so we known it must be either First, DOB or DOBFirst?
    let firstLowserCaseIndex = name.search(/[a-z]/);

    if (firstLowserCaseIndex < 0) {     // So, it is DOB
        return name.toLowerCase();
    }

    if (firstLowserCaseIndex === 1) {   // So, it is First
        return name.toLowerCase();
    }

    // Else: It is DOBFirst
    return name.slice(0, firstLowserCaseIndex - 1).toLowerCase()    // First word
        + name.slice(firstLowserCaseIndex - 1);                     // Remaining
}
